import { Center, Flex, Spinner } from "@chakra-ui/react";
import { ReactElement } from "react";

const LoadingScreen = (): ReactElement => {
    return (
        <Center width={"100vw"} height={"100vh"}>
            <Flex alignItems={'center'}>
                <Spinner
                    thickness='4px'
                    speed='0.65s'
                    emptyColor='gray.200'
                    color='teal.500'
                    size='xl'
                />
            </Flex>
        </Center>);
};

export default LoadingScreen;